export const CookieToken = 'X-Authorization';
